import React from 'react';
import { Typography } from '@material-ui/core';
import { HealtheraButton } from '../../../healtheraComponents';
import { Header, Container } from '../../Shared/Table';
import ClinicsListContainer from './components/ClinicsListContainer';
import { useHistory } from 'react-router';

const ClinicsList = () => {
  const history = useHistory();

  function addNewClinic() {
    history.push('/clinics/create');
  }

  return (
    <Container>
      <Header>
        <Typography variant="h4">Clinics</Typography>
        <HealtheraButton onClick={addNewClinic}>Add new</HealtheraButton>
      </Header>
      <ClinicsListContainer />
    </Container>
  );
};
export default ClinicsList;
